import { z } from 'zod'

import { SerializedBusinessErrorSchema } from 'shared/api/common/schemas/errors'

export const InvalidLinkErrorSchema = SerializedBusinessErrorSchema.extend({
  field: z.literal('share_hash'),
})

export const BlankPageErrorSchema = SerializedBusinessErrorSchema.extend({
  field: z.literal('page_id'),
})
